import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface AuthUser {
  id: string
  email: string
  name?: string
  isSuperUser?: boolean
}

interface AuthState {
  user: AuthUser | null
  activeProjectId: string | null
  setUser: (user: AuthUser | null) => void
  setActiveProjectId: (id: string | null) => void
  signOut: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      activeProjectId: null,
      setUser: (user) => set({ user }),
      setActiveProjectId: (id) => set({ activeProjectId: id }),
      signOut: () => set({ user: null, activeProjectId: null }),
    }),
    {
      name: 'bluedatalake-auth',
    }
  )
)
